var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",staticStyle:{"position":"relative"}},[_c('header',[_c('Navbar')],1),_c('section',[_c('AppMain')],1),_c('footer',{staticStyle:{"height":"128px","width":"100%"}},[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }